import { AbstractControl, ValidatorFn } from '@angular/forms';
import { environment } from 'src/environments/local/environment';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const re = environment.phoneNumberRegex;
    const valid = re.test(control.value);
    return valid ? null : { invalidPhoneNumber: true };
  };
}
